import React from 'react'
import ChartPie from '../../../components/ChartPie'

const TicketsBySeverity = ({ticketsSeverity}) => {
  // Prepare data: remove tailwind classes from color so ChartPie uses default hex colors
  const chartData = ticketsSeverity.map(({ color, ...rest }) => rest);

  return (
    <div className="w-full h-full">
      <ChartPie 
        data={chartData} 
        title="Tickets por Gravedad" 
        dataKey="count" 
        nameKey="label" 
        colors={['#22c55e', '#fcd34d','#ef4444']}
      />
    </div>
  )
}

export default TicketsBySeverity
